import axios from "axios"
import { common_api, crm_api } from "../../../Config"

export const fetchLastMISPId = async () => {
    return await axios.get(crm_api + '/Misp/v1/last-misp-id')
}

export const fetchEmployees = async () => {
    return await axios.get(crm_api + '/admin/allemployesdata')
    // return await axios.get('https://p23oxyscde.execute-api.ap-south-1.amazonaws.com/Stage/admin/usermanagement/0')
}

export const validateUserByPhone = (payload) => {
    return axios.post(crm_api + '/Misp/v1/user/validateUser', payload); // prod
    // return axios.post('http://localhost:5000/Misp/v1/user/validateUser', payload);
};

export const generateOtp = (payload) => {
    // return axios.post('https://5il6my5wxc.execute-api.ap-south-1.amazonaws.com/Prod/Posp/v1/user/generateOTP', payload); 
    return axios.post(common_api + '/messages/v1/sms', payload);
    // return axios.post('http://localhost:8084/messages/v1/sms', payload);

};

export const otpValidation = (payload) => {
    // return axios.post('https://5il6my5wxc.execute-api.ap-south-1.amazonaws.com/Prod/Posp/v1/user/validateOTP', payload);
    return axios.post(common_api + '/messages/v1/sms', payload);
    // return axios.post('http://localhost:8084/messages/v1/sms', payload);

};

export const insertMispProfileDetails = (payload) =>{
    return axios.post(crm_api + '/Misp/v1/profileDetails' , payload)
}

export const fetchMispData = (phone)=>{
    return axios.get(crm_api + '/Misp/v1/profileDetails/' + phone)
}

export const updatePospProfileData = () =>{

}

export const updateMispBankDetails = () =>{

}

export const updateMispDocument = () =>{
    
}

export const addOfflinePolicy = (payload) => {
    // return axios.post('https://75e8n7v4uj.execute-api.ap-south-1.amazonaws.com/Prod/insurance/policy', payload);
    return axios.post(common_api + '/insurance/policy', payload);

}

export const getLifePlains = () => {
    return axios.get('https://lmv-web-staging.s3.ap-south-1.amazonaws.com/JSON/admin/lifeplans.json')
}